var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Year } from '@/models/Year';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
let YearSelect = class YearSelect extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.years = [];
        this.selectedYear = '';
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.getYears();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onYearSelected(selectedYear) {
        if (!selectedYear) {
            return;
        }
        const year = this.years.find((year) => {
            return year.id === selectedYear;
        });
        if (!year) {
            return;
        }
        const selectedPeriod = [`${year.starts_at}`, `${year.ends_at}`];
        this.$emit('selectedYearChanged', selectedPeriod);
    }
    // #endregion
    // #region Async methods (api calls only)
    async getYears() {
        await new Year()
            .all()
            .then((years) => {
            this.years = years;
            if (this.$route.query.year) {
                this.selectedYear = this.$route.query.year;
            }
            else {
                if (years && years.length) {
                    this.selectedYear = years[years.length - 1].id;
                }
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
YearSelect = __decorate([
    Component({})
], YearSelect);
export default YearSelect;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
